import formatTime from "@/utils/formatTime";
import useRequest from "@/utils/useReq";
import { Button } from "antd";
import { getVipTypeByUser, VipTitleMap } from "../../../constants/vip";
import { getCurrentVipZone, getUserRight } from "../../../services";
import imageUrl from "../../../utils/imageUrl";
import HBIcon from "../../HBIcon";
import Image from "../../Image";
import styles from "./index.module.less";

export default function VipHeader({
  user,
  userRight,
  hasBack = true,
  onBack,
} = {}) {
  // 权益信息
  const { data: rightData } = useRequest(async () => {
    const rightData = userRight || (await getUserRight());
    const vipInfo = rightData?.vips[0];
    const { err, order_no } = vipInfo
      ? await getCurrentVipZone(vipInfo.system_code)
      : {};

    return {
      ...rightData,
      order_no,
      err,
    };
  });

  const vipInfo = rightData?.vips[0];
  const vipType = getVipTypeByUser(user);

  return (
    <div className={styles.header}>
      {hasBack && (
        <Button
          type="text"
          className={styles.back}
          onClick={() => {
            onBack && onBack();
          }}
        >
          <HBIcon type="ic_arrowThinLeft" />
        </Button>
      )}
      <div className={styles.avatar}>
        <Image
          src={imageUrl(user.avatar, { width: 40 })}
          width="40"
          height="40"
          alt="头像"
        />
        <div>
          <div className={styles.account}>充值账号：{user.username}</div>
          {vipInfo ? (
            <div className={styles.info}>
              <span>
                {VipTitleMap[vipType]}
                {formatTime(vipInfo.expires_at, "YYYY/MM/DD")}
                到期 | 每天可下载
                {rightData.downloadCount[0] &&
                  rightData.downloadCount[0].quantity}
                个 (今日剩余
                <span className={styles.number}>
                  {rightData.downloadCount[0] &&
                    rightData.downloadCount[0].left}
                </span>
                张)
              </span>
            </div>
          ) : (
            <div className={styles.info}>你当前还不是VIP哦~</div>
          )}
        </div>
      </div>
    </div>
  );
}
